import React from 'react';

import { PageHeader } from 'antd';
import Axios from 'axios';

import styled from 'styled-components';

//import { removeStatementLog } from '@libs/NwLogs';
import { getMoment } from '@libs/NwMoment';

import { getContactName } from '@hooks/API/Contact/UseContactsList';
import { usePayment, useDeletePayment } from '@hooks/API/UsePayments';

import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import StyleVariables from '@components/Gui/StyleVariables';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const PaymentHeader = styled.div`
    z-index: 1030;
    top: ${(props) => (props.$inDrawer ? '0' : '5rem')};
    width: 100%;
    position: ${(props) => (props.$inDrawer ? 'relative' : 'sticky')};

    .ant-page-header {
        padding-right: 1rem;
        margin: 1rem;
        min-height: 4rem;
        border-bottom: ${(props) => props.theme.DefaultBorder};

        .ant-page-header-title-view-title {
            font-size: 2rem;
            line-height: 1;
        }

        .page-title {
            font-size: ${(props) => props.theme.FontSizeLg};
        }

        p {
            margin: 0;
            font-size: 0.9rem;
            line-height: 1.1em;
            font-weight: 400;
        }
    }
    .confirm-button {
        color: ${StyleVariables.PrimaryColor};
        text-decoration: underline;
        cursor: pointer;
        user-select: none;
        font-size: 14px;
        font-weight: 500;
    }
`;

const PaymentPageHeader = ({ paymentId, contactType = 'model', handleShowEditDrawer, inDrawer, onDelete }) => {
    const { data: paymentData } = usePayment(paymentId);
    const { mutateAsync: onDeleteModelPayment } = useDeletePayment();

    // Dynamic labels based on contact type
    const getContactTypeLabel = () => {
        switch (contactType) {
            case 'model':
                return 'model';
            case 'agency':
                return 'agency';
            case 'service':
                return 'service';
            default:
                return 'contact';
        }
    };

    const onConvertToAdvancePayment = async () => {
        try {
            await Axios.put(`/payments/converttoadvancepayment/${paymentId}`, null);
            onDelete();
        } catch (e) {
            console.error('error converting to advance payment', e);
        }
    };

    const onDeleteWholePayment = async () => {
        try {
            await onDeleteModelPayment(paymentId);
            onDelete();
        } catch (e) {
            console.error('error deleting', e);
        }
    };

    const paymentActions = [
        {
            name: '',
            key: 'edit',
            pinned: true,
            icon: byPrefixAndName.fasl['pen'],
            action: handleShowEditDrawer,
        },
    ];
    if (contactType?.toLowerCase() === 'model') {
        paymentActions.push({
            name: 'CONVERT TO ADVANCE PAYMENT',
            type: 'delete',
            confirmationLabel: `This will remove all the statement lines from this payment (setting them as unpaid) and then will convert the payment to an advance payment (a negative line on the ${getContactTypeLabel()} statement). You will not able to undo that`,
            confirmationButtonLabel: 'CONVERT TO ADVANCE PAYMENT',
            confirmationButtonIcon: byPrefixAndName.fasl['arrow-right-arrow-left'],
            confirmationPlacement: 'bottomLeft',
            icon: byPrefixAndName.fasl['arrow-right-arrow-left'],
            key: 'convert-to-advance',
            action: onConvertToAdvancePayment,
        });
    }
    paymentActions.push({
        name: 'DELETE PAYMENT',
        type: 'delete',
        confirmationLabel:
            'This will remove all the statement lines from this payment (setting them as unpaid) and then delete the payment. You will not able to undo that',
        confirmationPlacement: 'bottomLeft',
        icon: byPrefixAndName.fasl['trash-alt'],
        key: 'delete',
        action: onDeleteWholePayment,
    });

    return (
        <PaymentHeader $inDrawer={inDrawer}>
            <PageHeader
                title={
                    paymentData && (
                        <div className="page-title">
                            {getContactName(paymentData.ContactID)}
                            {paymentData.Name &&
                                paymentData.Name.toLowerCase() !== 'payment' &&
                                paymentData.Name !== getMoment(paymentData.Date).format('MMM Do YY') && (
                                    <>
                                        <em> - </em>
                                        {paymentData.Name}
                                    </>
                                )}
                            <em> - </em>
                            {getMoment(paymentData.Date).format('MMM Do YYYY')}
                        </div>
                    )
                }
                subTitle={false}
                extra={[<NwDropDownMenu size="small" key="extra" actions={paymentActions} />]}
            ></PageHeader>
        </PaymentHeader>
    );
};

export default PaymentPageHeader;
